<template>
    <a
        :href="props.url"
        class="flex items-center justify-center gap-3 rounded-lg2 bg-white p-3 text-sm font-semibold text-gray-900 shadow-xs ring-1 ring-inset ring-stone-200 hover:bg-gray-50 focus:outline-none focus:ring-2"
        :class="{
            'focus:ring-primary': !useBookingFormThemeCssVariables,
            'focus:ring-booking-form-theme-main-background-color':
                useBookingFormThemeCssVariables,
        }"
    >
        <Icon
            name="google"
            class="w-5 h-5"
        />
        <span class="text-sm font-semibold leading-6">
            <slot />
        </span>
    </a>
</template>

<script setup lang="ts">
    import Icon from '@/Shared/Component/Icon.vue'

    interface GoogleSocialAuthButtonProps {
        url: string
        useBookingFormThemeCssVariables?: boolean
    }

    const props = defineProps<GoogleSocialAuthButtonProps>()
</script>
